/*
 * qb-hero-diapo.js — QB Wuré (08/10/2026)
 * Diaporama de sections/qb-hero-editorial.liquid (actif dès qu'un bloc « QB - Diapositive »
 * existe). Le défilement et les flèches sont ceux de qb-_lib-carrousel ; ce script ajoute :
 *   - le défilement automatique toutes les N s (data-qb-diapo-duree, 0 = jamais), de la
 *     dernière bannière à la première ;
 *   - les points de navigation (aria-current) et le bouton pause / lecture ;
 *   - l'en-tête transparent en couleurs normales sur une bannière claire
 *     (attribut data-qb-entete-sombre sur html, CSS dans la section) ;
 *   - aucune avance automatique : pause demandée, survol à la souris, focus clavier dans
 *     la bannière, section hors écran, onglet caché, réduction des animations demandée,
 *     bloc sélectionné dans l'éditeur (WCAG 2.2.2 : tout contenu qui défile seul se
 *     met en pause).
 * Une instance par section, montée au chargement et sur shopify:section:load, démontée sur
 * shopify:section:unload (observateur, écouteurs et minuteurs retirés).
 */
(function () {
	if (window.__qbHeroDiapo) return;
	window.__qbHeroDiapo = true;

	var calme = window.matchMedia('(prefers-reduced-motion: reduce)');

	function Diapo(racine) {
		this.racine = racine;
		this.piste = racine.querySelector('[data-qb-track]');
		this.points = Array.prototype.slice.call(racine.querySelectorAll('[data-qb-diapo-point]'));
		this.nb = racine.querySelectorAll('[data-qb-slide]').length;
		this.duree = (Number(racine.getAttribute('data-qb-diapo-duree')) || 0) * 1000;
		this.arret = calme.matches;
		this.survol = false;
		this.clavier = false;
		this.visible = true;
		this.modeEditeur = !!(window.Shopify && window.Shopify.designMode);
		this.editeur = this.modeEditeur;
		this.mort = false;
		this.chrono = null;
		this.minuteur = null;

		this.surClic = this.surClic.bind(this);
		this.surDefilement = this.surDefilement.bind(this);
		this.surEntree = this.surEntree.bind(this);
		this.surSortie = this.surSortie.bind(this);
		this.surFocus = this.surFocus.bind(this);
		this.surOnglet = this.surOnglet.bind(this);

		racine.addEventListener('click', this.surClic);
		racine.addEventListener('pointerenter', this.surEntree);
		racine.addEventListener('pointerleave', this.surSortie);
		racine.addEventListener('focusin', this.surFocus);
		racine.addEventListener('focusout', this.surFocus);
		racine.addEventListener('keyup', this.surFocus);
		this.piste.addEventListener('scroll', this.surDefilement, { passive: true });
		document.addEventListener('visibilitychange', this.surOnglet);

		var self = this;
		if ('IntersectionObserver' in window) {
			this.observateur = new IntersectionObserver(function (entrees) {
				self.visible = entrees[entrees.length - 1].isIntersecting;
				self.armer();
			});
			this.observateur.observe(racine);
		}

		this.synchroBouton();
		this.maj();
	}

	Diapo.prototype.detruire = function () {
		this.racine.removeEventListener('click', this.surClic);
		this.racine.removeEventListener('pointerenter', this.surEntree);
		this.racine.removeEventListener('pointerleave', this.surSortie);
		this.racine.removeEventListener('focusin', this.surFocus);
		this.racine.removeEventListener('focusout', this.surFocus);
		this.racine.removeEventListener('keyup', this.surFocus);
		this.piste.removeEventListener('scroll', this.surDefilement);
		document.removeEventListener('visibilitychange', this.surOnglet);
		if (this.observateur) this.observateur.disconnect();
		this.mort = true;
		document.documentElement.removeAttribute('data-qb-entete-sombre');
		clearTimeout(this.chrono);
		clearTimeout(this.minuteur);
	};

	Diapo.prototype.courant = function () {
		var l = this.piste.clientWidth || 1;
		return Math.max(0, Math.min(this.nb - 1, Math.round(this.piste.scrollLeft / l)));
	};

	/* saut : retour direct à la première bannière, sans balayer toutes les autres. */
	Diapo.prototype.aller = function (i, saut) {
		this.piste.scrollTo({ left: i * this.piste.clientWidth, behavior: calme.matches || saut ? 'auto' : 'smooth' });
	};

	/* Après chaque défilement : point actif mis à jour, compte relancé. */
	Diapo.prototype.maj = function () {
		var i = this.courant();
		this.points.forEach(function (p, j) {
			if (j === i) p.setAttribute('aria-current', 'true');
			else p.removeAttribute('aria-current');
		});
		/* La navigation prend la couleur du texte de la bannière affichée (texte foncé sur photo claire). */
		var slides = this.racine.querySelectorAll('[data-qb-slide]');
		var contenu = slides[i] && slides[i].querySelector('.qb-hero__contenu');
		if (contenu) this.racine.style.setProperty('--qb-diapo-nav', getComputedStyle(contenu).color);
		document.documentElement.toggleAttribute('data-qb-entete-sombre', !!(slides[i] && slides[i].hasAttribute('data-qb-diapo-claire')));
		/* Bannières hors écran : ni lues ni focalisables. Image de la suivante chargée d'avance. */
		for (var j = 0; j < slides.length; j++) slides[j].inert = j !== i;
		var suite = slides[(i + 1) % this.nb];
		var image = suite && suite.querySelector('img[loading="lazy"]');
		if (image) image.loading = 'eager';
		this.armer();
	};

	Diapo.prototype.armer = function () {
		clearTimeout(this.chrono);
		if (this.mort || !this.duree || this.arret || this.survol || this.clavier || !this.visible || this.editeur || document.hidden || this.nb < 2) return;
		var self = this;
		this.chrono = setTimeout(function () {
			var suivante = (self.courant() + 1) % self.nb;
			self.aller(suivante, suivante === 0);
		}, this.duree);
	};

	Diapo.prototype.synchroBouton = function () {
		this.racine.toggleAttribute('data-qb-diapo-arret', this.arret);
		var b = this.racine.querySelector('[data-qb-diapo-basculer]');
		if (b) b.setAttribute('aria-label', this.arret ? 'Relancer le défilement' : 'Mettre en pause le défilement');
	};

	Diapo.prototype.surClic = function (event) {
		var point = event.target.closest('[data-qb-diapo-point]');
		if (point) {
			this.aller(Number(point.getAttribute('data-qb-diapo-point')));
			return;
		}
		if (event.target.closest('[data-qb-diapo-basculer]')) {
			this.arret = !this.arret;
			this.synchroBouton();
			this.armer();
		}
	};

	Diapo.prototype.surDefilement = function () {
		clearTimeout(this.chrono);
		clearTimeout(this.minuteur);
		this.minuteur = setTimeout(this.maj.bind(this), 150);
	};

	Diapo.prototype.surEntree = function (event) {
		if (event.pointerType !== 'mouse') return;
		this.survol = true;
		this.armer();
	};

	Diapo.prototype.surSortie = function (event) {
		if (event.pointerType !== 'mouse') return;
		this.survol = false;
		this.armer();
	};

	/* Focus clavier dans la bannière (focusin/out, et keyup pour un focus déjà placé à la
	   souris puis repris au clavier) : on ne fait pas défiler sous le lecteur. Distinct du
	   survol, sinon un clic de souris sur une flèche relancerait le défilement. */
	Diapo.prototype.surFocus = function () {
		var self = this;
		setTimeout(function () {
			var f = document.activeElement;
			try {
				self.clavier = self.racine.contains(f) && f.matches(':focus-visible');
			} catch (e) {
				/* Safari < 15.4 ne connaît pas :focus-visible : tout focus interne retient. */
				self.clavier = self.racine.contains(f);
			}
			self.armer();
		}, 0);
	};

	Diapo.prototype.surOnglet = function () {
		this.armer();
	};

	function monter(contexte) {
		(contexte || document).querySelectorAll('[data-qb-diapo]').forEach(function (racine) {
			if (!racine.__qbHeroDiapo) racine.__qbHeroDiapo = new Diapo(racine);
		});
	}

	function demonter(contexte) {
		contexte.querySelectorAll('[data-qb-diapo]').forEach(function (racine) {
			if (racine.__qbHeroDiapo) {
				racine.__qbHeroDiapo.detruire();
				racine.__qbHeroDiapo = null;
			}
		});
	}

	document.addEventListener('shopify:section:load', function (event) { monter(event.target); });
	document.addEventListener('shopify:section:unload', function (event) { demonter(event.target); });

	/* Éditeur : sélectionner un bloc affiche sa bannière et suspend le défilement. */
	document.addEventListener('shopify:block:select', function (event) {
		var slide = event.target.closest && event.target.closest('[data-qb-slide]');
		var racine = slide && slide.closest('[data-qb-diapo]');
		var d = racine && racine.__qbHeroDiapo;
		if (!d) return;
		d.editeur = true;
		d.aller(Array.prototype.indexOf.call(racine.querySelectorAll('[data-qb-slide]'), slide));
		d.armer();
	});
	document.addEventListener('shopify:block:deselect', function (event) {
		var racine = event.target.closest && event.target.closest('[data-qb-diapo]');
		var d = racine && racine.__qbHeroDiapo;
		if (!d) return;
		d.editeur = d.modeEditeur;
		d.armer();
	});

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { monter(); });
	else monter();
})();
